"use client"

import styled from "@emotion/styled"
import { Drawer } from "@mui/material"
import { InitIframeTransactionData } from "api"
import { useLocale } from "next-intl"
import { useEffect, useMemo } from "react"
import { useIsDesktop } from "ui"

const IframeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
`

const StyledDrawer = styled(Drawer)`
  box-shadow: none;
  border: none;
  ::before {
    content: none;
  }
`

type Props = {
  paymentIframeData: InitIframeTransactionData | null
  formIsSubmitted: boolean
  handleFail: () => void
  // eslint-disable-next-line no-unused-vars
  handleSuccess: (_orderId?: string) => void
  handleClose: () => void
}

const PaymentIFrameRenderer = ({
  paymentIframeData,
  formIsSubmitted,
  handleFail,
  handleSuccess,
  handleClose,
}: Props) => {
  const locale = useLocale()
  const isDesktop = useIsDesktop()
  const url = useMemo(
    () => `${paymentIframeData?.url}&lang=${locale === "en" ? "en" : "he"}`,
    [locale, paymentIframeData?.url],
  )

  useEffect(() => {
    const messegeHandler = async (event: MessageEvent) => {
      const action = event?.data?.action
      // NOTE: https://grow-il.readme.io/reference/postmassage for-iframes-integration
      // console.log("event.data", {
      //   action,
      //   data: event.data,
      // })
      switch (action) {
        case "close": {
          handleClose()
          break
        }
        case "payment": {
          if (
            event?.data?.status === "success" ||
            event?.data?.status === 1 ||
            event?.data?.success === "True"
          ) {
            handleSuccess(event?.data?.orderId)
          }
          if (event?.data?.status === "fail" || event?.data?.status === 0) {
            handleFail()
          }
          break
        }

        case "failed_to_load_page": {
          handleFail()
          break
        }
        default: {
          // do nothing
          break
        }
      }
    }

    window.addEventListener("message", messegeHandler)
    return () => {
      window.removeEventListener("message", messegeHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledDrawer
      open={!!paymentIframeData && !formIsSubmitted}
      anchor={isDesktop ? "left" : "bottom"}
      transitionDuration={800}
      onClose={() => {
        handleClose()
      }}
      sx={{ zIndex: 999999 }}
      SlideProps={{
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: 658 },
          height: { xs: "90%", md: "100%" },
          borderRadius: {
            xs: "16px 16px 0 0",
            md: 0,
          },
        },
      }}
    >
      <IframeContainer>
        {<StyledIframe onError={handleFail} src={url} title="Payment" width="100%" height="100%" />}
      </IframeContainer>
    </StyledDrawer>
  )
}
export default PaymentIFrameRenderer
